const API_BASE_URL = process.env.REACT_APP_DATA_SERVICE_URL;
const API_ACTION_URL = process.env.REACT_APP_ACTION_SERVICE_URL
const API_BASE_APP_URL = process.env.REACT_APP_API_BASE_URL_CREATE;
const ACCESS_SERVICE_URL = process.env.REACT_APP_ACCESS_SERVICE_URL
const NOTIFICATION_URL = process.env.REACT_APP_NOTIFICATION_SERVICE_URL;

import axios from 'axios';
import FileDownload from "js-file-download";

import { Request } from "./clientHelper";

export class PrivilegeService {
 
    static getPrivileges(data) {
        let uri = ACCESS_SERVICE_URL + `/privileges/list`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/privileges/list`;
        console.log("getPrivileges === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'POST',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
            payload: data.payload || {}
        });
    }
    static getPrivilegeById(data) {
        let uri = ACCESS_SERVICE_URL + `/privileges/${data.id}`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/privileges/${data.id}`;
        console.log("getPrivileges === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'GET',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static deletePrivilegeById(data) {
        let uri = ACCESS_SERVICE_URL + `/privileges/${data.id}`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/privileges/${data.id}`;
        // console.log("deletePrivileges === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'DELETE',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static createPrivilege(data) {
        let uri = ""
        if (data.id == "new") {
            uri = ACCESS_SERVICE_URL + `/privileges`;
            // let localUrl = "http://localhost:5007"
            // uri = localUrl + `/privileges`;
        }
        else {
            uri = ACCESS_SERVICE_URL + `/privileges/${data.id}`;
            // let localUrl = "http://localhost:5007"
            // uri = localUrl + `/privileges/${data.id}`;
        }
        console.log("getPrivileges === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: data.data._id ? 'PUT' : 'POST',
            payload: data.data,
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static getSystemOperations(data) {
        let uri = ACCESS_SERVICE_URL + `/privileges/operations`;
        // let localUrl = "http://localhost:5007"
        // let uri = localUrl + `/privileges/operations`;
        console.log("getPrivileges === form api", uri)
        let appid = data.appId
        return Request(uri, {
            url: uri,
            method: 'GET',
            headers: {
                appId: appid,
                orgId: data.orgId
            },
        });
    }
    static getMemberPrivileges(data) {

        // let uri = 'http://localhost:5007/privileges/member/';
        let uri = ACCESS_SERVICE_URL + `/privileges/member/`;
        console.log("Cmng to actions 5 ==> uri ==>>", uri)
        return Request(uri, {
            method: 'GET',
            // payload: data.data,
            headers: {
                appid: data.appId,
                orgid: data.orgId
            },
        });
    }
}

export function apiBaseAddress() {
    return API_BASE_URL;
}